<template>
  <div class="signup-box has-border-primary">
    <div>
      <img :src="imageSrc" :height="size" :width="size"/>
    </div>
    <b>{{title}}</b>
    <div class="buttons">
      <router-link :to="{name: 'sign-up', params: {type}}" tag="a"
        class="button is-primary is-small is-rounded">
        Sign Up
      </router-link>
      <router-link :to="{name: 'login'}" tag="a"
        class="button is-primary is-small is-rounded">
        Log in
      </router-link>
    </div>
    <div>
      <a @click="modalOpen=true"><b class="has-small-text">
        Why create a skippersbook profile?
      </b></a>
      <b-modal :active.sync="modalOpen" has-modal-card>
        <div class="modal-card" style="width: auto">
          <div class="has-text-left modal-card-head is-size-4">You will be able to:</div>
          <div class="modal-card-body">
            <ol class="has-text-left why-list">
              <li v-for="i in why" :key="i">{{i}}</li>
            </ol>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalOpen: false,
    };
  },
  props: {
    imageSrc: String,
    title: String,
    size: {
      type: Number,
      default: 60,
    },
    type: String,
    why: Array,
  },
};
</script>

<style lang="scss" scoped>
.signup-box {
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0.8rem 0.2rem 0.8rem 0.2rem;
}
.buttons {
  display: flex;
  justify-content: space-evenly;
}

.modal-card-body {
  padding: 3rem;
}
.has-small-text {
  font-size: 0.8rem;
}
</style>
